import { MemberNotesList } from 'client/courses/components/member-notes-list';

type Props = {
  userId: UUID;
};

export function AdminNotes({ userId }: Props) {
  return (
    <section class="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-4 dark:bg-gray-900">
      <h2 class="text-sm font-semibold uppercase tracking-wide text-gray-500">Notes</h2>
      <MemberNotesList memberUserId={userId} />
    </section>
  );
}
